export default __webpack_public_path__ + "static/media/logo-small.ab6b6406.png";